import AbortController from "abort-controller";

class APIRequest {
  constructor (rest, method, path, options) {
    this.rest = rest;
    this.method = method;
    this.route = options.route;
    this.options = options;
    this.retries = 0;

    let queryString = "";
    if (options.query) {
      const query = Object.entries(options.query)
        .filter(([, value]) => ![null, "null", "undefined"].includes(value) && typeof value !== "undefined")
        .flatMap(([key, value]) => (Array.isArray(value) ? value.map(v => [key, v]) : [[key, value]]));
      queryString = new URLSearchParams(query).toString();
    }
    
    if (queryString) {
      this.path = `${path}?${queryString}`;
    } else {
      this.path = path;
    }
  }

  make () {
    const API =
      this.options.versioned === false
        ? this.rest.options.http.api
        : `${this.rest.options.http.api}/v${this.rest.options.http.version}`;

    const url = API + this.path;

    let headers = {};

    if (this.options.use_authorization !== false) headers.Authorization = this.rest.getAuth();

    headers["User-Agent"] = "ModCord/2.0 (Dashboard Rest Manager)";
    if (this.options.headers) headers = Object.assign(headers, this.options.headers);

    let body;
    if (this.options.data != null) {
      body = JSON.stringify(this.options.data);
      headers["Content-Type"] = "application/json";
    }

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), this.rest.options.restRequestTimeout);

    return fetch(url, {
      method: this.method,
      headers,
      body,
      signal: controller.signal,
    }).finally(() => clearTimeout(timeout));
  }
}

export default APIRequest;
